'use client';

var _excluded = ["containerRef"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { usePortalManager } from "./chunk-HK66PB7M.mjs"; // src/portal.tsx

import { useSafeLayoutEffect } from "@chakra-ui/react-use-safe-layout-effect";
import { createContext } from "@chakra-ui/react-context";
import { createPortal } from "react-dom";
import { useEffect, useMemo, useRef, useState } from "react";
import { jsx } from "react/jsx-runtime";

var _createContext = createContext({
  strict: false,
  name: "PortalContext"
}),
    _createContext2 = _slicedToArray(_createContext, 2),
    PortalContextProvider = _createContext2[0],
    usePortalContext = _createContext2[1];

var PORTAL_CLASSNAME = "chakra-portal";
var PORTAL_SELECTOR = ".chakra-portal";

var Container = function Container(props) {
  return /* @__PURE__ */jsx("div", {
    className: "chakra-portal-zIndex",
    style: {
      position: "absolute",
      zIndex: props.zIndex,
      top: 0,
      left: 0,
      right: 0 // NB: Don't add `bottom: 0`, it makes the entire app unusable
      // @see https://github.com/chakra-ui/chakra-ui/issues/3201

    },
    children: props.children
  });
};

var DefaultPortal = function DefaultPortal(props) {
  var appendToParentPortal = props.appendToParentPortal,
      children = props.children;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      tempNode = _useState2[0],
      setTempNode = _useState2[1];

  var portal = useRef(null);

  var _useState3 = useState({}),
      _useState4 = _slicedToArray(_useState3, 2),
      forceUpdate = _useState4[1];

  useEffect(function () {
    return forceUpdate({});
  }, []);
  var parentPortal = usePortalContext();
  var manager = usePortalManager();
  useSafeLayoutEffect(function () {
    if (!tempNode) return;
    var doc = tempNode.ownerDocument;
    var host = appendToParentPortal ? parentPortal != null ? parentPortal : doc.body : doc.body;
    if (!host) return;
    portal.current = doc.createElement("div");
    portal.current.className = PORTAL_CLASSNAME;
    host.appendChild(portal.current);
    forceUpdate({});
    var portalNode = portal.current;
    return function () {
      if (host.contains(portalNode)) {
        host.removeChild(portalNode);
      }
    };
  }, [tempNode]);

  var _children = (manager == null ? void 0 : manager.zIndex) ? /* @__PURE__ */jsx(Container, {
    zIndex: manager == null ? void 0 : manager.zIndex,
    children: children
  }) : children;

  return portal.current ? createPortal( /* @__PURE__ */jsx(PortalContextProvider, {
    value: portal.current,
    children: _children
  }), portal.current) : /* @__PURE__ */jsx("span", {
    ref: function ref(el) {
      if (el) setTempNode(el);
    }
  });
};

var ContainerPortal = function ContainerPortal(props) {
  var children = props.children,
      containerRef = props.containerRef,
      appendToParentPortal = props.appendToParentPortal;
  var containerEl = containerRef.current;
  var host = containerEl != null ? containerEl : typeof window !== "undefined" ? document.body : void 0;
  var portal = useMemo(function () {
    var node = containerEl == null ? void 0 : containerEl.ownerDocument.createElement("div");
    if (node) node.className = PORTAL_CLASSNAME;
    return node;
  }, [containerEl]);

  var _useState5 = useState({}),
      _useState6 = _slicedToArray(_useState5, 2),
      forceUpdate = _useState6[1];

  useSafeLayoutEffect(function () {
    return forceUpdate({});
  }, []);
  useSafeLayoutEffect(function () {
    if (!portal || !host) return;
    host.appendChild(portal);
    return function () {
      host.removeChild(portal);
    };
  }, [portal, host]);

  if (host && portal) {
    return createPortal( /* @__PURE__ */jsx(PortalContextProvider, {
      value: appendToParentPortal ? portal : null,
      children: children
    }), portal);
  }

  return null;
};

function Portal(props) {
  var portalProps = _objectSpread({
    appendToParentPortal: true
  }, props);

  var containerRef = portalProps.containerRef,
      rest = _objectWithoutProperties(portalProps, _excluded);

  return containerRef ? /* @__PURE__ */jsx(ContainerPortal, _objectSpread({
    containerRef: containerRef
  }, rest)) : /* @__PURE__ */jsx(DefaultPortal, _objectSpread({}, rest));
}

Portal.className = PORTAL_CLASSNAME;
Portal.selector = PORTAL_SELECTOR;
Portal.displayName = "Portal";
export { Portal };